import {
  DIALOGUERECORD_FETCHING,
  DIALOGUERECORD_SUCCESS,
  DIALOGUERECORD_FAILED,
} from "../actions/types";

const initialState = {
  result: null,
  isFetching: false,
  isError: false,
};

export default function (state = initialState, action) {
  const { type, payload } = action;
  switch (type) {
    case DIALOGUERECORD_FETCHING:
      return { ...state, result: null, isFetching: true, isError: false };
    case DIALOGUERECORD_FAILED:
      return { ...state, result: null, isFetching: false, isError: true };
    case DIALOGUERECORD_SUCCESS:
      return { ...state, result: payload, isFetching: false, isError: false };
    default:
      return state;
  }
}
